export default __webpack_public_path__ + "static/media/screen6.18c6c252.svg";